import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ReferralCalculatorComponent} from './referral-calculator.component';

const routes: Routes = [
    {
        path: 'referral-calculator',
        component: ReferralCalculatorComponent,
        data: {animation: 'referral-calculator'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ReferralCalculatorRoutingModule {
}
